import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// API Base URL
const BASE_URL = "https://newalemny.3almny.app/api";

// Async thunk for first registration
export const firstRegistration = createAsyncThunk(
  "auth/firstRegistration",
  async (phoneData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/users/first_regist`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(phoneData),
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle validation errors
        if (data.statusCode === 422 && data.result) {
          const errorMessages = [];
          Object.values(data.result).forEach((errors) => {
            if (Array.isArray(errors)) {
              errorMessages.push(...errors);
            }
          });
          return rejectWithValue(errorMessages.join(", "));
        }

        return rejectWithValue(data.message || "حدث خطأ في التسجيل");
      }

      return data;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

// Async thunk for OTP verification
export const verifyOTP = createAsyncThunk(
  "auth/verifyOTP",
  async (otpData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/users/check_code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(otpData),
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle validation errors
        if (data.statusCode === 422 && data.result) {
          const errorMessages = [];
          Object.values(data.result).forEach((errors) => {
            if (Array.isArray(errors)) {
              errorMessages.push(...errors);
            }
          });
          return rejectWithValue(errorMessages.join(", "));
        }

        return rejectWithValue(data.message || "رمز التحقق غير صحيح");
      }

      return data;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

// Async thunk for getting stages
export const getStages = createAsyncThunk(
  "auth/getStages",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/stages/get_all`);
      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "حدث خطأ في جلب المراحل");
      }

      return data.result;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

// Async thunk for getting classes by stage
export const getClassesByStage = createAsyncThunk(
  "auth/getClassesByStage",
  async (stageId, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${BASE_URL}/stages/stage_classes/${stageId}`
      );
      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "حدث خطأ في جلب الفصول");
      }

      return data.result;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

// Async thunk for second registration
export const secondRegistration = createAsyncThunk(
  "auth/secondRegistration",
  async (userData, { rejectWithValue }) => {
    try {
      const formData = new FormData();

      // Add all fields to FormData
      Object.keys(userData).forEach((key) => {
        if (key === "prof_img" && userData[key]) {
          formData.append(key, userData[key]);
        } else if (userData[key] !== null && userData[key] !== undefined) {
          formData.append(key, userData[key]);
        }
      });

      const response = await fetch(`${BASE_URL}/users/second_regist`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle validation errors
        if (data.statusCode === 422 && data.result) {
          const errorMessages = [];
          Object.values(data.result).forEach((errors) => {
            if (Array.isArray(errors)) {
              errorMessages.push(...errors);
            }
          });
          return rejectWithValue(errorMessages.join(", "));
        }

        return rejectWithValue(data.message || "حدث خطأ في إكمال التسجيل");
      }

      return data;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

// Login async thunk
export const login = createAsyncThunk(
  "auth/login",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/users/login`,
        {
          phone: credentials.phone,
          password: credentials.password,
          fcm_token: "rejkjre",
          device_id: "3F90C17E-F182-48AC-8CD8-339CFE007F1C",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data;
      if (data.status === "success") {
        localStorage.setItem("token3almny", data.result.token);
        localStorage.setItem("user3almny", JSON.stringify(data.result));
        return data.result;
      } else {
        return rejectWithValue(data.message || "فشل تسجيل الدخول");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        
        // Handle validation errors (422 status code)
        if (error.response.status === 422 && errorData.result) {
          const errorMessages = [];
          Object.values(errorData.result).forEach((errors) => {
            if (Array.isArray(errors)) {
              errorMessages.push(...errors);
            }
          });
          return rejectWithValue(errorMessages.join(", "));
        }
        
        return rejectWithValue(errorData.message || "فشل تسجيل الدخول");
      } else if (error.message && error.message.toLowerCase().includes("network")) {
        // في حال ظهور network error بسبب كود 407
        return rejectWithValue("الحساب مسجل على جهاز اخر");
      } else {
        return rejectWithValue("حدث خطأ غير متوقع");
      }
    }
  }
);

// Send reset password code
export const sendResetCode = createAsyncThunk(
  "auth/sendResetCode",
  async (phoneData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/users/send_code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(phoneData),
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle validation errors
        if (data.statusCode === 422 && data.result) {
          const errorMessages = [];
          Object.values(data.result).forEach((errors) => {
            if (Array.isArray(errors)) {
              errorMessages.push(...errors);
            }
          });
          return rejectWithValue(errorMessages.join(", "));
        }

        return rejectWithValue(data.message || "حدث خطأ في إرسال رمز التحقق");
      }

      return data;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

// Check reset code
export const checkResetCode = createAsyncThunk(
  "auth/checkResetCode",
  async (codeData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/users/check_code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(codeData),
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle validation errors
        if (data.statusCode === 422 && data.result) {
          const errorMessages = [];
          Object.values(data.result).forEach((errors) => {
            if (Array.isArray(errors)) {
              errorMessages.push(...errors);
            }
          });
          return rejectWithValue(errorMessages.join(", "));
        }

        return rejectWithValue(data.message || "رمز التحقق غير صحيح");
      }

      return data;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

// Reset password
export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (passwordData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/users/reset_password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(passwordData),
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle validation errors
        if (data.statusCode === 422 && data.result) {
          const errorMessages = [];
          Object.values(data.result).forEach((errors) => {
            if (Array.isArray(errors)) {
              errorMessages.push(...errors);
            }
          });
          return rejectWithValue(errorMessages.join(", "));
        }

        return rejectWithValue(data.message || "حدث خطأ في إعادة تعيين كلمة المرور");
      }

      return data;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

// Fetch user profile
export const fetchUserProfile = createAsyncThunk(
  "auth/fetchUserProfile",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) throw new Error("No authentication token found");

      const response = await axios.get(`${BASE_URL}/users/profile`, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = response.data;

      if (data.status === "success") {
        return data.result;
      } else {
        return rejectWithValue(data.message || "حدث خطأ في جلب البيانات الشخصية");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.message || "حدث خطأ في جلب البيانات الشخصية");
      } else if (error.message && error.message.toLowerCase().includes("network")) {
        return rejectWithValue("حدث خطأ في الاتصال بالخادم");
      } else {
        return rejectWithValue(error.message || "حدث خطأ غير متوقع");
      }
    }
  }
);

// Update user profile
export const updateUserProfile = createAsyncThunk(
  "auth/updateUserProfile",
  async (profileData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) throw new Error("No authentication token found");

      const formData = new FormData();

      // Add all fields to FormData
      Object.keys(profileData).forEach((key) => {
        if (key === "prof_img" && profileData[key]) {
          formData.append(key, profileData[key]);
        } else if (profileData[key] !== null && profileData[key] !== undefined) {
          formData.append(key, profileData[key]);
        }
      });

      const response = await axios.post(`${BASE_URL}/users/update_profile`, formData, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      const data = response.data;

      if (data.status === "success") {
        return data.result;
      } else {
        return rejectWithValue(data.message || "حدث خطأ في تحديث البيانات الشخصية");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        
        // Handle validation errors
        if (errorData.statusCode === 422 && errorData.result) {
          const errorMessages = [];
          Object.values(errorData.result).forEach((errors) => {
            if (Array.isArray(errors)) {
              errorMessages.push(...errors);
            }
          });
          return rejectWithValue(errorMessages.join(", "));
        }
        
        return rejectWithValue(errorData.message || "حدث خطأ في تحديث البيانات الشخصية");
      } else if (error.message && error.message.toLowerCase().includes("network")) {
        return rejectWithValue("حدث خطأ في الاتصال بالخادم");
      } else {
        return rejectWithValue(error.message || "حدث خطأ غير متوقع");
      }
    }
  }
);



// Logout action
export const logout = createAsyncThunk("auth/logout", async () => {
  // Clear localStorage
  localStorage.removeItem("token3almny");
  localStorage.removeItem("user3almny");
  localStorage.removeItem("userType");
  return null;
});

// Check if user is already logged in
export const checkAuthStatus = createAsyncThunk(
  "auth/checkStatus",
  async () => {
    const token = localStorage.getItem("token3almny");
    const userData = localStorage.getItem("user3almny");

    if (token && userData) {
      return JSON.parse(userData);
    }
    return null;
  }
);

const initialState = {
  userType: null,
  phone: null,
  isLoading: false,
  error: null,
  otpSent: false,
  otpVerified: false,
  userData: null,
  stages: [],
  classes: [],
  stagesLoading: false,
  classesLoading: false,
  registrationComplete: false,
  // Login related fields
  isAuthenticated: false,
  loginLoading: false,
  loginError: null,
  currentUser: null,
  // Reset password related fields
  resetCodeSent: false,
  resetCodeVerified: false,
  resetLoading: false,
  resetError: null,
  // Profile related fields
  profileLoading: false,
  profileError: null,
  profileData: null,
  updateProfileLoading: false,
  updateProfileError: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserType: (state, action) => {
      state.userType = action.payload;
    },
    setPhone: (state, action) => {
      state.phone = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    resetAuth: (state) => {
      state.userType = null;
      state.phone = null;
      state.isLoading = false;
      state.error = null;
      state.otpSent = false;
      state.otpVerified = false;
      state.userData = null;
      state.stages = [];
      state.classes = [];
      state.stagesLoading = false;
      state.classesLoading = false;
      state.registrationComplete = false;
    },
    clearLoginError: (state) => {
      state.loginError = null;
    },
    clearResetError: (state) => {
      state.resetError = null;
    },
    resetResetPassword: (state) => {
      state.resetCodeSent = false;
      state.resetCodeVerified = false;
      state.resetLoading = false;
      state.resetError = null;
    },
  },
  extraReducers: (builder) => {
    // First Registration
    builder
      .addCase(firstRegistration.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(firstRegistration.fulfilled, (state) => {
        state.isLoading = false;
        state.otpSent = true;
      })
      .addCase(firstRegistration.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Verify OTP
    builder
      .addCase(verifyOTP.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(verifyOTP.fulfilled, (state) => {
        state.isLoading = false;
        state.otpVerified = true;
      })
      .addCase(verifyOTP.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Get Stages
    builder
      .addCase(getStages.pending, (state) => {
        state.stagesLoading = true;
      })
      .addCase(getStages.fulfilled, (state, action) => {
        state.stagesLoading = false;
        state.stages = action.payload;
      })
      .addCase(getStages.rejected, (state) => {
        state.stagesLoading = false;
      });

    // Get Classes by Stage
    builder
      .addCase(getClassesByStage.pending, (state) => {
        state.classesLoading = true;
      })
      .addCase(getClassesByStage.fulfilled, (state, action) => {
        state.classesLoading = false;
        state.classes = action.payload;
      })
      .addCase(getClassesByStage.rejected, (state) => {
        state.classesLoading = false;
      });

    // Second Registration
    builder
      .addCase(secondRegistration.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(secondRegistration.fulfilled, (state) => {
        state.isLoading = false;
        state.registrationComplete = true;
      })
      .addCase(secondRegistration.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Login
    builder
      .addCase(login.pending, (state) => {
        state.loginLoading = true;
        state.loginError = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loginLoading = false;
        state.isAuthenticated = true;
        state.currentUser = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.loginLoading = false;
        state.loginError = action.payload;
      });

    // Logout
    builder.addCase(logout.fulfilled, (state) => {
      state.isAuthenticated = false;
      state.currentUser = null;
    });

    // Check Auth Status
    builder.addCase(checkAuthStatus.fulfilled, (state, action) => {
      if (action.payload) {
        state.isAuthenticated = true;
        state.currentUser = action.payload;
      } else {
        state.isAuthenticated = false;
        state.currentUser = null;
      }
    });

    // Send Reset Code
    builder
      .addCase(sendResetCode.pending, (state) => {
        state.resetLoading = true;
        state.resetError = null;
      })
      .addCase(sendResetCode.fulfilled, (state) => {
        state.resetLoading = false;
        state.resetCodeSent = true;
      })
      .addCase(sendResetCode.rejected, (state, action) => {
        state.resetLoading = false;
        state.resetError = action.payload;
      });

    // Check Reset Code
    builder
      .addCase(checkResetCode.pending, (state) => {
        state.resetLoading = true;
        state.resetError = null;
      })
      .addCase(checkResetCode.fulfilled, (state) => {
        state.resetLoading = false;
        state.resetCodeVerified = true;
      })
      .addCase(checkResetCode.rejected, (state, action) => {
        state.resetLoading = false;
        state.resetError = action.payload;
      });

    // Reset Password
    builder
      .addCase(resetPassword.pending, (state) => {
        state.resetLoading = true;
        state.resetError = null;
      })
      .addCase(resetPassword.fulfilled, (state) => {
        state.resetLoading = false;
        state.resetCodeSent = false;
        state.resetCodeVerified = false;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.resetLoading = false;
        state.resetError = action.payload;
      });

    // Fetch User Profile
    builder
      .addCase(fetchUserProfile.pending, (state) => {
        state.profileLoading = true;
        state.profileError = null;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.profileData = action.payload;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.profileLoading = false;
        state.profileError = action.payload;
      });

    // Update User Profile
    builder
      .addCase(updateUserProfile.pending, (state) => {
        state.updateProfileLoading = true;
        state.updateProfileError = null;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.updateProfileLoading = false;
        state.profileData = action.payload;
        // Update currentUser with new data
        if (state.currentUser) {
          state.currentUser = { ...state.currentUser, ...action.payload };
        }
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.updateProfileLoading = false;
        state.updateProfileError = action.payload;
      });


  },
});

export const { setUserType, setPhone, clearError, resetAuth, clearLoginError, clearResetError, resetResetPassword } =
  authSlice.actions;
export default authSlice.reducer;
